import {useCommonItems} from "../../../../../../contexts/CommonItensProvider";
import {useAppContext} from "../../../../../../contexts/AppContext";
import {useEffect, useState} from "react";
import {carregaPontosEntrega} from "../../configs/functions";
import {getDefaultValueSelectField} from "../../../../../../utils";
import {Button, Divider, Grid, InputAdornment, MenuItem, TextField, Typography} from "@mui/material";
import {getFormErrorMessage} from "../../../../../../configs/functions";
import {TooltipSelectDisabled} from "../../../../../common/TooltipSelectDisabled";
import {Controller} from "react-hook-form";
import {grey} from "@mui/material/colors";
import LanIcon from "@mui/icons-material/Lan";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import FourGMobiledataIcon from "@mui/icons-material/FourGMobiledata";
import {CopyAll} from "@mui/icons-material";
import {CopyEquipmentSettingsDialog} from "../CopyEquipmentSettingsDialog";

export function FirstStepMachineForm({ values, maquina, empresas, register, errors, clearErrors, control, setQtdMotores, setValue }) {
    const { exibirDialog, handleCloseDialog, exibirAlerta } = useCommonItems();
    const { dadosUsuario } = useAppContext();

    const [pontosEntrega, setPontosEntrega] = useState([]);
    const [selectedEmpresaId, setSelectedEmpresaId] = useState(null);

    const equipmentContractTypes = [{ value: 'locacao', text: 'Locação' }, { value: 'venda', text: 'Venda' }];
    const quantidadeMotoresValues = [{ value: 36, text: '36 Motores' }, { value: 60, text: '60 Motores' }];

    const loadPontosEntrega = async (empresaId) => {
        try {
            const filterOnlyActives = {
                // status: 1,
                id_empresa: empresaId
            };
            const response = await carregaPontosEntrega(filterOnlyActives);
            const pontosDeEntrega = response.data.data;

            setPontosEntrega(pontosDeEntrega);

            const defaultValuePontoEntrega =
                values.id_ponto_entrega
                || getDefaultValueSelectField(maquina, maquina?.pontoEntrega?.id, pontosDeEntrega);

            setValue('id_ponto_entrega', defaultValuePontoEntrega, { shouldDirty: true });
        } catch (error) {
            exibirAlerta('Erro ao carregar os Pontos de Entrega', '', 'error');
        }
    }

    useEffect(() => {
        if (values.id_empresa) {
            setSelectedEmpresaId(values.id_empresa);
        }
        return () => setSelectedEmpresaId(null);
    }, [values.id_empresa]);

    async function getValuesFromEmpresaId(empresaId) {
        exibirDialog('Carregando dados da Empresa...');
        try {
            await loadPontosEntrega(empresaId);
        } catch (error) {
            exibirAlerta('Erro ao carregar os Pontos de Entrega', '', 'error');
        } finally {
            handleCloseDialog();
        }
    }

    useEffect(() => {
        if (selectedEmpresaId) {
            getValuesFromEmpresaId(selectedEmpresaId);
        }
    }, [selectedEmpresaId]);

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={2}
        >
            <Grid item xs={12} md={4}>
                <TextField
                    autoFocus
                    InputLabelProps={{ shrink: true }}
                    margin='dense'
                    label='Nome'
                    placeholder='Digite o nome da Máquina'
                    name='nome'
                    fullWidth
                    {...register("nome", { required: true })}
                    error={!!errors.nome}
                    helperText={getFormErrorMessage(errors, 'nome')}
                    autoComplete='off'
                    inputProps={{ form: { autocomplete: 'off' } }}
                    disabled={!dadosUsuario.isSempher}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    margin='dense'
                    label='Código de Identificação'
                    placeholder='Digite o código de identificação'
                    name='tag_identificacao'
                    fullWidth
                    {...register("tag_identificacao")}
                    error={!!errors.tag_identificacao}
                    helperText={!!errors.tag_identificacao ? getFormErrorMessage(errors, 'tag_identificacao') : 'O código será criado automaticamente se não preenchido.'}
                    disabled={!dadosUsuario.isSempher}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    select
                    label="Quantidade de motores"
                    name='qtd_motores'
                    fullWidth
                    defaultValue={maquina ? maquina.qtd_motores : values.qtd_motores || 36}
                    error={!!errors.qtd_motores}
                    helperText={getFormErrorMessage(errors, 'qtd_motores')}
                    {...register("qtd_motores", { required: true })}
                    sx={{ mt: 1 }}
                    onChange={(e) => {
                        const value = parseInt(e.target.value);
                        setQtdMotores(value)
                        setValue('qtd_motores', value, { shouldDirty: true })
                    }}
                    disabled={!dadosUsuario.isSempher}
                >
                    {quantidadeMotoresValues.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.text}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={12}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    margin='dense'
                    label='Descrição'
                    placeholder='Digite a Descrição'
                    name='descricao'
                    fullWidth
                    {...register("descricao")}
                    multiline
                    rows={3}
                    error={!!errors.descricao}
                    helperText={getFormErrorMessage(errors, 'descricao')}
                    disabled={!dadosUsuario.isSempher}
                />
            </Grid>

            {empresas &&
                <>
                    <Grid item xs={12} md={4}>
                        <TooltipSelectDisabled
                            isDisabled={!(!!maquina)}
                            text="Não é possível alterar a Empresa de uma Máquina já cadastrada"
                        >
                            <Controller
                                name='id_empresa'
                                control={control}
                                rules={{ required: true }}
                                defaultValue={maquina ? maquina.empresa.id : ""}
                                render={({ field: { ref, onChange, ...field } }) => (
                                    <TextField
                                        {...field}
                                        select
                                        fullWidth
                                        sx={{ mt: 1 }}
                                        label="Empresa"
                                        disabled={!!maquina || !dadosUsuario.isSempher}
                                        defaultValue={maquina ? maquina.empresa.id : ""}
                                        onChange={(e) => {
                                            setSelectedEmpresaId(e.target.value);
                                            setValue('id_empresa', e.target.value, { shouldDirty: true })
                                            setValue('id_ponto_entrega', '', { shouldDirty: true })
                                            if (e.target.value) {
                                                clearErrors('id_empresa');
                                            }
                                        }}
                                        error={!!errors.id_empresa}
                                        helperText={getFormErrorMessage(errors, 'id_empresa')}
                                    >
                                        {empresas.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.nomeFantasia}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            />
                        </TooltipSelectDisabled>
                    </Grid>

                    {pontosEntrega &&
                        <Grid item xs={12} md={4}>
                            <TooltipSelectDisabled isDisabled={selectedEmpresaId}>
                                <Controller
                                    name='id_ponto_entrega'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue={maquina ? maquina.pontoEntrega.id : ""}
                                    render={({ field: { ref, onChange, ...field } }) => (
                                        <TextField
                                            {...field}
                                            select
                                            fullWidth
                                            sx={{ mt: 1 }}
                                            label="Ponto de Entrega"
                                            disabled={!dadosUsuario.isSempher || !selectedEmpresaId}
                                            onChange={(e) => {
                                                setValue('id_ponto_entrega', e.target.value, { shouldDirty: true })
                                                if (e.target.value) {
                                                    clearErrors('id_ponto_entrega');
                                                }
                                            }}
                                            error={!!errors.id_ponto_entrega}
                                            helperText={getFormErrorMessage(errors, 'id_ponto_entrega')}
                                        >
                                            {pontosEntrega.length > 0 ? (
                                                // Separar itens habilitados e desabilitados
                                                [
                                                    ...pontosEntrega.filter(option => option.status !== 0).map(option => (
                                                        <MenuItem key={option.id} value={option.id}>
                                                            {option.nome}
                                                        </MenuItem>
                                                    )),
                                                    ...pontosEntrega.filter(option => option.status === 0).map(option => (
                                                        <MenuItem key={option.id} value={option.id} disabled>
                                                            {option.nome} - (Inativo)
                                                        </MenuItem>
                                                    ))
                                                ]
                                            ) : (
                                                <MenuItem disabled>Nenhum disponível</MenuItem>
                                            )}
                                        </TextField>
                                    )}
                                />
                            </TooltipSelectDisabled>
                        </Grid>
                    }
                </>
            }

            <Grid item xs={12} md={4}>
                <TextField
                    select
                    label="Tipo de Contrato"
                    name='tipo_contrato'
                    fullWidth
                    disabled={!dadosUsuario.isSempher}
                    defaultValue={maquina ? maquina.tipo_contrato : 'locacao'}
                    error={!!errors.tipo_contrato}
                    helperText={getFormErrorMessage(errors, 'tipo_contrato')}
                    {...register("tipo_contrato", { required: true })}
                    sx={{ mt: 1 }}
                >
                    {equipmentContractTypes.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.text}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={12} md={12}>
                <Divider xs={12} sx={{ mt: 3 }} textAlign="center">
                    <Typography variant="subtitle1" sx={{ color: grey[700] }}>
                        Dados de conexão
                    </Typography>
                </Divider>
            </Grid>

            {maquina && (
                <>
                    <Grid item xs={12} md={4}>
                        <TextField
                            autoFocus
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                            label="IP Ethernet"
                            placeholder="Ex: 192.168.0.1"
                            name="ip_ethernet"
                            defaultValue={maquina?.ip_ethernet ?? ''}
                            fullWidth
                            {...register("ip_ethernet")}
                            error={!!errors.ipEthernet}
                            helperText={getFormErrorMessage(errors, "ip_ethernet")}
                            disabled
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <LanIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <TextField
                            autoFocus
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                            label="IP Wifi"
                            placeholder="Ex: 192.168.0.1"
                            name="ip_wifi"
                            defaultValue={maquina?.ipWifi ?? ''}
                            fullWidth
                            {...register("ip_wifi")}
                            error={!!errors.ip_wifi}
                            helperText={getFormErrorMessage(errors, "ip_wifi")}
                            disabled
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <RssFeedIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <TextField
                            autoFocus
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                            label="IP 4G"
                            placeholder="Ex: 10.0.0.1"
                            name="ip_4g"
                            defaultValue={maquina?.ip4g ?? ''}
                            fullWidth
                            {...register("ip_4g")}
                            error={!!errors.ip_4g}
                            helperText={getFormErrorMessage(errors, "ip_4g")}
                            disabled
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <FourGMobiledataIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </>
            )}

            <Grid item xs={12} md={4}>
                <TextField
                    autoFocus
                    InputLabelProps={{ shrink: true }}
                    margin="dense"
                    label="MAC Ethernet"
                    placeholder="Ex: AA:BB:CC:DD:EE:FF"
                    name="mac_ethernet"
                    defaultValue={maquina?.macEthernet ?? ''}
                    fullWidth
                    {...register("mac_ethernet")}
                    error={!!errors.mac_ethernet}
                    helperText={getFormErrorMessage(errors, "mac_ethernet")}
                    disabled={!dadosUsuario.isSempher}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <LanIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    autoFocus
                    InputLabelProps={{ shrink: true }}
                    margin="dense"
                    label="MAC Wifi"
                    placeholder="Ex: AA:BB:CC:DD:EE:FF"
                    name="mac_wifi"
                    defaultValue={maquina?.macWifi ?? ''}
                    fullWidth
                    {...register("mac_wifi")}
                    error={!!errors.mac_wifi}
                    helperText={getFormErrorMessage(errors, "mac_wifi")}
                    disabled={!dadosUsuario.isSempher}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <RssFeedIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    autoFocus
                    InputLabelProps={{ shrink: true }}
                    margin="dense"
                    label="MAC 4G"
                    placeholder="Ex: AA:BB:CC:DD:EE:FF"
                    name="mac_4g"
                    defaultValue={maquina?.mac4g ?? ''}
                    fullWidth
                    {...register("mac_4g")}
                    error={!!errors.mac_4g}
                    helperText={getFormErrorMessage(errors, "mac_4g")}
                    disabled={!dadosUsuario.isSempher}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <FourGMobiledataIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
        </Grid>
    )
}